module.exports = "img/flags/KN.13ddd2f.png";